// extracted by mini-css-extract-plugin
export default {"recos":"N2-z","productCardOverride":"O2-z","rowHasBadge":"P2-z"};